import { render, staticRenderFns } from "./TableGroups.vue?vue&type=template&id=22b98f55&"
import script from "./TableGroups.vue?vue&type=script&lang=ts&"
export * from "./TableGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports